import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDownCondensedLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.1017 6.4186C13.2387 6.65835 13.1552 6.9639 12.9155 7.10089L8.24884 9.76756C8.09516 9.85534 7.90643 9.85534 7.75275 9.76756L3.08608 7.10089C2.84634 6.9639 2.76293 6.65835 2.89988 6.4186C3.03687 6.17886 3.34243 6.09545 3.58217 6.2324L8.00079 8.75714L12.4194 6.2324C12.6592 6.09545 12.9647 6.17886 13.1017 6.4186Z",
			fill: "currentColor"
		})
	})
});
export default SvgChevronDownCondensedLine;
